// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — confirm.styled.classic.js, новая — confirm.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './confirm.styled.classic';
import * as cp from './confirm.styled.cp';

export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
export const Place = isCp ? cp.Place : classic.Place;
export const Title = isCp ? cp.Title : classic.Title;
